import { useMemo } from "react";
import { useGetArticlesList } from "shared-apis/api";
import { useExpensesState } from "atoms/expensesAtom";
import { ExpensesItem } from "types";

import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "./styles.module.scss";

export const ExpensesBody = (): JSX.Element => {
  const { expensesState, setExpensesState } = useExpensesState();

  const { data: expensesList = [] } = useGetArticlesList({});

  const sortedExpensesList = useMemo(() => {
    const arr = [...expensesList];
    const { length } = arr;

    for (let i = 0; i < length - 1; i++) {
      for (let j = 0; j < length - i - 1; j++) {
        if (arr[j].position > arr[j + 1].position) {
          const temp = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = temp;
        }
      }
    }

    return arr;
  }, [expensesList]);

  const handleClick = (item: ExpensesItem) => {
    setExpensesState({ activeItem: item });
  };

  return (
    <div className={styles.container}>
      {sortedExpensesList?.map((item: ExpensesItem) => (
        <Row
          key={item.articleid}
          onClick={() => handleClick(item)}
          isActive={expensesState.activeItem?.articleid === item.articleid}
        >
          <Paragraph>{item.name}</Paragraph>
        </Row>
      ))}
    </div>
  );
};
